// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlaceAnAd_wrap__5Ap7o {
  padding: 28px 30px;
  min-width: 100%;
  width: 100%;
  border-radius: 40px;
  transition: 0.35s ease;
  cursor: pointer;
  height: 100%;
}
.PlaceAnAd_wrap__linker__zMDwl {
  max-width: 353px;
}
.PlaceAnAd_wrap__up__AzM47 {
  display: flex;
  column-gap: 15px;
  align-items: center;
}
.PlaceAnAd_wrap__up__icon__wrap__2CQt1 {
  background-color: #fff;
  padding: 17px;
  border-radius: 100%;
  transition: 0.35s ease;
}
.PlaceAnAd_wrap__up__icon__wrap__2CQt1 svg {
  transition: 0.35s ease;
  height: 33px;
  width: 33px;
}
.PlaceAnAd_wrap__down__iBN1r {
  margin-top: 40px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.PlaceAnAd_wrap__5Ap7o .PlaceAnAd_arrow__mrHU1 svg {
  height: 50px;
  width: 50px;
  margin-left: 20px;
  margin-bottom: -4px;
  transition: 0.35s ease;
  color: #000;
}
.PlaceAnAd_wrap__5Ap7o:hover .PlaceAnAd_arrow__mrHU1 svg, .PlaceAnAd_wrap__5Ap7o:active .PlaceAnAd_arrow__mrHU1 svg {
  margin-bottom: 10px;
}

.PlaceAnAd_accent__eoGVZ {
  background-color: #ff6f19;
}

@media (max-width: 1280px) {
  .PlaceAnAd_wrap__linker__zMDwl {
    max-width: 100%;
  }
}
@media (max-width: 1024px) {
  .PlaceAnAd_wrap__linker__zMDwl {
    max-width: 100%;
  }
  .PlaceAnAd_wrap__5Ap7o:hover .PlaceAnAd_wrap__up__link__ctkUp, .PlaceAnAd_wrap__5Ap7o:active .PlaceAnAd_wrap__up__link__ctkUp {
    margin-bottom: 0px;
  }
  .PlaceAnAd_wrap__5Ap7o:hover .PlaceAnAd_arrow__mrHU1 svg, .PlaceAnAd_wrap__5Ap7o:active .PlaceAnAd_arrow__mrHU1 svg {
    margin-bottom: 0px !important;
    margin-top: 0px !important;
  }
}
@media (max-width: 728px) {
  .PlaceAnAd_wrap__up__icon__wrap__2CQt1 {
    padding: 10px;
  }
  .PlaceAnAd_wrap__up__icon__wrap__2CQt1 svg {
    width: 25px;
    height: 25px;
  }
  .PlaceAnAd_wrap__down__iBN1r {
    margin-top: 1rem;
  }
  .PlaceAnAd_wrap__down__under__i52BD {
    font-size: 18px;
    margin-top: 0;
  }
  .PlaceAnAd_wrap__linker__zMDwl {
    height: 230px;
  }
  .PlaceAnAd_wrap__linker__zMDwl .PlaceAnAd_wrap__5Ap7o {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mainPage/placeAnAd/PlaceAnAd.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBCDM;EDEN,sBCHI;EDIJ,eAAA;EACA,YAAA;AADD;AAGC;EACC,gBAAA;AADF;AAIC;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AAIE;EACC,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBCpBE;ADkBL;AAIG;EACC,sBCvBC;EDwBD,YAAA;EACA,WAAA;AAFJ;AAOC;EACC,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AALF;AASE;EACC,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBC3CE;ED4CF,WC7CI;ADsCP;AAcG;EACC,mBAAA;AAZJ;;AAkBA;EACC,yBC/DQ;ADgDT;;AAkBA;EACC;IACC,eAAA;EAfA;AACF;AAkBA;EAEE;IACC,eAAA;EAjBD;EAsBC;IACC,kBAAA;EApBF;EA2BE;IACC,6BAAA;IACA,0BAAA;EAzBH;AACF;AA+BA;EAGG;IACC,aAAA;EA/BF;EAgCE;IACC,WAAA;IACA,YAAA;EA9BH;EAmCA;IACC,gBAAA;EAjCD;EAmCC;IACC,eAAA;IACA,aAAA;EAjCF;EAsCD;IACC,aAAA;EApCA;EAsCA;IACC,aAAA;IACA,sBAAA;IACA,8BAAA;EApCD;AACF","sourcesContent":["@import '../../../variables';\n\n.wrap {\n\tpadding: 28px 30px;\n\tmin-width: 100%;\n\twidth: 100%;\n\tborder-radius: $br40;\n\ttransition: $tr;\n\tcursor: pointer;\n\theight: 100%;\n\n\t&__linker {\n\t\tmax-width: 353px;\n\t}\n\n\t&__up {\n\t\tdisplay: flex;\n\t\tcolumn-gap: 15px;\n\t\talign-items: center;\n\n\t\t&__icon__wrap {\n\t\t\tbackground-color: #fff;\n\t\t\tpadding: 17px;\n\t\t\tborder-radius: 100%;\n\t\t\ttransition: $tr;\n\n\t\t\tsvg {\n\t\t\t\ttransition: $tr;\n\t\t\t\theight: 33px;\n\t\t\t\twidth: 33px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__down {\n\t\tmargin-top: 40px;\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tjustify-content: space-between;\n\t}\n\n\t.arrow {\n\t\tsvg {\n\t\t\theight: 50px;\n\t\t\twidth: 50px;\n\t\t\tmargin-left: 20px;\n\t\t\tmargin-bottom: -4px;\n\t\t\ttransition: $tr;\n\t\t\tcolor: $dark;\n\t\t}\n\t}\n\n\t&:hover,\n\t&:active {\n\t\t.arrow {\n\t\t\tsvg {\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.accent {\n\tbackground-color: $accent;\n}\n\n@media (max-width: 1280px) {\n\t.wrap__linker {\n\t\tmax-width: 100%;\n\t}\n}\n\n@media (max-width: 1024px) {\n\t.wrap {\n\t\t&__linker {\n\t\t\tmax-width: 100%;\n\t\t}\n\n\t\t&:hover,\n\t\t&:active {\n\t\t\t.wrap__up__link {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t}\n\n\t\t&:hover,\n\t\t&:active {\n\t\t\t.arrow {\n\t\t\t\tsvg {\n\t\t\t\t\tmargin-bottom: 0px !important;\n\t\t\t\t\tmargin-top: 0px !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 728px) {\n\t.wrap {\n\t\t&__up {\n\t\t\t&__icon__wrap {\n\t\t\t\tpadding: 10px;\n\t\t\t\tsvg {\n\t\t\t\t\twidth: 25px;\n\t\t\t\t\theight: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&__down {\n\t\t\tmargin-top: 1rem;\n\n\t\t\t&__under {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t.wrap__linker {\n\t\theight: 230px;\n\n\t\t.wrap {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-between;\n\t\t}\n\t}\n}\n","$accent: #ff6f19;\n$grey: #eaeaea;\n$w: #fff;\n$dark: #000;\n$tr: 0.35s ease;\n$br40: 40px;\n$Jost: 'Jost-Regular';\n$Jost300: 'Jost-Light';\n$Jost500: 'Jost-Medium';\n$Jost600: 'Jost-SemiBold';\n$Jost700: 'Jost-Bold';\n$Jost800: 'Jost-ExtraBold';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `PlaceAnAd_wrap__5Ap7o`,
	"wrap__linker": `PlaceAnAd_wrap__linker__zMDwl`,
	"wrap__up": `PlaceAnAd_wrap__up__AzM47`,
	"wrap__up__icon__wrap": `PlaceAnAd_wrap__up__icon__wrap__2CQt1`,
	"wrap__down": `PlaceAnAd_wrap__down__iBN1r`,
	"arrow": `PlaceAnAd_arrow__mrHU1`,
	"accent": `PlaceAnAd_accent__eoGVZ`,
	"wrap__up__link": `PlaceAnAd_wrap__up__link__ctkUp`,
	"wrap__down__under": `PlaceAnAd_wrap__down__under__i52BD`
};
export default ___CSS_LOADER_EXPORT___;
